import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FirestoreDataService } from 'src/app/services/firestore-data.service';
// TypeScript interfaces for type safety
interface PCMData {
    days: number[];
    bg?: string;
    backButton: { url: string };
    ctaButton: { url: string; text: string };
    prize?: { image: string; text: string };
}

interface PCMSettings {
    ids?: { main: string; snow: string };
    canvas?: {
        width: number;
        height: number;
        rescaleMode: number;
        orientation: number;
        aspectRatio?: number;
        aspectRatioPercentage?: number;
    };
    cards?: {
        count: number;
        interactable: boolean;
        reveal_delay: number;
    };
    grid?: {
        zoom: number;
        zoom_time: number;
        width: number;
        height: number;
        dx: number;
        dy: number;
        cols?: number;
        rows?: number;
        size?: number;
    };
    snow?: {
        id: string;
        enabled: boolean;
        fixed_dt: number;
        dom_scaling: boolean;
        mobile_ratio: number;
        parent: string;
        shape: number;
    };
    anims?: {
        cards_appear: { enabled: boolean; delay: number };
        card_tick_appear: { enabled: boolean; delay: number };
    };
}

interface Particle {
    x: number;
    y: number;
    radius: number;
    speedY: number;
    speedX: number;
    driftPhase: number;
    driftSpeed: number;
    opacity: number;
}

@Component({
    selector: 'app-christmas-event',
    templateUrl: './christmas-event.html',
    styleUrls: ['./christmas-event.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ChristmasEvent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('pcmParent', { static: false }) pcmParentRef!: ElementRef;

    private PCM: any;
    private preloadImages = ["/assets/pcmImages/images/pcm_bg_4.jpg", "/assets/pcmImages/images/icon_points.png"];
    private pcmData!: PCMData;

    constructor(private router: Router, private authService: FirestoreDataService) {
        this.pcmData = {
            days: [],
            bg: "/assets/pcmImages/images/pcm_bg_4.jpg",
            backButton: {
                url: "/mainTabs/tabs/home"
            },
            ctaButton: {
                url: "/mainTabs/tabs/home",
                text: "Dismiss"
            },
            prize: {
                image: "/assets/pcmImages/images/icon_credit_0.png",
                text: "£5"
            }
        };
    }
    ngOnInit(): void {
        // Initialize PCM object structure
        this.initializePCM();

        this.authService.getV2CloudFunction("getuserentries", {}).subscribe(response => {

            if (response) {
                if (Array.isArray(response?.days)) {
                    this.pcmData.days = response?.days;
                }

                if (response?.prize) {
                    this.pcmData.prize = {
                        image: response.prize.image_url,
                        text: this.formatPrizeText(response.prize),

                    };
                }

                setTimeout(() => {
                    if (this.PCM && this.pcmParentRef?.nativeElement) {
                        this.PCM.Remove?.();
                        this.PCM.Init(this.preloadImages, this.pcmParentRef.nativeElement, this.pcmData, null);
                    }
                }, 200);
            }
        });
    }
    ngAfterViewInit(): void { }
    formatPrizeText(prize: any): string {
    if (!prize) return "";

    const value = prize.value ?? "";
    const text = prize.prize_text ?? "";

    // If the offer is discount-voucher we want: 50% OFF  (no space before %)
    if (prize.type === "discount_voucher") {
      return `${value}${text}`.trim();
    }

    // Other types: "1 Free Play", "10 Points", etc.
    return `${value} ${text}`.trim();
  }

    ngOnDestroy(): void {
        if (this.PCM && this.PCM.Remove) {
            this.PCM.Remove();
        }
    }

    private initializePCM(): void {
        const PCM: any = {
            online: false,
            isReady: false,
            preloadRequest: false,
            domElements: null as any,
            params: {} as any,
            defaultSettings: {} as any,
            settings: {} as PCMSettings,
            _ids: {} as any,
            inputs: {} as any,
            spinner: null as any,
            loader: {} as any,
            svgs: {} as any,
            data: null as PCMData | null,
            grid: null as any,
            SnowManager: null as any,
            STATEs: {
                DEFAULT: 0,
                ZOOMED: 1
            },
            PRIZE_STATEs: {
                MISSED: -1,
                AVAILABLE: 0,
                CLAIMED: 1,
                LOCKED: 2
            },
            isMobileOrTablet: function (): boolean {
                const ua = navigator.userAgent || (navigator as any).vendor || (window as any).opera;
                const isOldMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
                const isIPad = /iPad/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
                const isAndroidTablet = /Android/i.test(ua) && !/Mobile/i.test(ua);
                const isWindowsTablet = /Windows/i.test(ua) && navigator.maxTouchPoints > 1;
                return isOldMobile || isIPad || isAndroidTablet || isWindowsTablet;
            },
            isOnMobile: null as boolean | null,
            assetsHolder: {} as any,
            imagesPath: "/assets/pcmImages/images/",
            IMAGEs: [
                "pcm_atlas.png",
                "card_front_face.png"
            ],
            state: 0,
            log: function (log: any): void {
                //console.log("<PCM>",log);
            },
            warn: function (log: any): void {
                console.warn("<PCM>", log);
            },
            error: function (log: any): void {
                console.error("<PCM>", log);
            },
            getRandom: function (min: number, max: number): number {
                return Math.random() * (max - min) + min;
            },
            addButtonsListeners: function (buttons: HTMLElement[]): void {
                for (let i = 0; i < buttons.length; i++) {
                    buttons[i].dataset['screen'] = "main";
                    if (buttons[i].dataset['enabled'] == null)
                        buttons[i].dataset['enabled'] = "1";
                    switch (buttons[i].dataset['anim']) {
                        case "frame":
                            buttons[i].addEventListener('click', PCM.onClickHandler);
                            break;

                        case "toggle":
                            if (!buttons[i].dataset['toggled'])
                                buttons[i].dataset['toggled'] = "0";
                            break;

                        case "scale":
                            if (!buttons[i].dataset['scale'])
                                buttons[i].dataset['scale'] = "1";
                            buttons[i].addEventListener('click', PCM.onClickHandler);
                            break;
                    }
                    if (this.isOnMobile) {
                        buttons[i].addEventListener('touchstart', PCM.onBtnTouched);
                    } else {
                        buttons[i].addEventListener('mousedown', PCM.onBtnTouched);
                    }
                }
            },
            removeButtonsListeners: function (buttons: HTMLElement[]): void {
                for (let i = 0; i < buttons.length; i++) {
                    switch (buttons[i].dataset['anim']) {
                        case "frame":
                            buttons[i].removeEventListener('click', PCM.onClickHandler);
                            break;

                        case "scale":
                            buttons[i].removeEventListener('click', PCM.onClickHandler);
                            break;
                    }
                    if (this.isOnMobile) {
                        buttons[i].removeEventListener('touchstart', PCM.onBtnTouched);
                    } else {
                        buttons[i].removeEventListener('mousedown', PCM.onBtnTouched);
                    }
                }
            },
            ASSETs: {
                IMAGE: "img"
            },
            RESCALE_MODEs: {
                WIDTH: 0,
                HEIGHT: 1,
                MIN: 2,
                MAX: 3,
                VALUE: 4
            },
            ORIENTATIONs: {
                PORTRAIT: 0,
                LANDSCAPE: 1,
                BOTH: 2
            },
            SHAPEs: {
                SPRITE: 0,
                CIRCLE: 1
            },
            Preload: function (addImages: string[] | null, parent: HTMLElement | null, data: PCMData): void {
                this.loader = {} as any;
                this.loader.assetsLoaded = 0;
                this.loader.assetsToLoad = 0;
                if (parent) {
                    this.spinner = {} as any;
                    this.spinner.domElements = {} as any;
                    this.spinner.domElements.parent = parent;
                    this.spinner.domElements.parent.innerHTML = '<div class="pcm_spinner_p"><div class="pcm_spinner"></div></div>';
                    if (data) {
                        this.loader.data = data;
                    }
                }
                this.assetsHolder[this.ASSETs.IMAGE] = {} as any;
                if (addImages) {
                    if (Array.isArray(addImages)) {
                        for (let no = 0; no < addImages.length; no++) {
                            this.assetsHolder[this.ASSETs.IMAGE]["add_" + no] = {} as any;
                            this.assetsHolder[this.ASSETs.IMAGE]["add_" + no].name = addImages[no];
                            this.assetsHolder[this.ASSETs.IMAGE]["add_" + no].img = new Image();
                            this.assetsHolder[this.ASSETs.IMAGE]["add_" + no].img.onload = () => { PCM.onAssetLoaded(); };
                            this.assetsHolder[this.ASSETs.IMAGE]["add_" + no].img.src = addImages[no];
                            if (this.spinner) { this.loader.assetsToLoad++; }
                        }
                    }
                }
                if (this.preloadRequest) { return; }
                this.preloadRequest = true;
                for (let no = 0; no < this.IMAGEs.length; no++) {
                    this.assetsHolder[this.ASSETs.IMAGE][no] = {} as any;
                    this.assetsHolder[this.ASSETs.IMAGE][no].name = this.IMAGEs[no];
                    this.assetsHolder[this.ASSETs.IMAGE][no].img = new Image();
                    this.assetsHolder[this.ASSETs.IMAGE][no].img.onload = () => { PCM.onAssetLoaded(); };
                    this.assetsHolder[this.ASSETs.IMAGE][no].img.src = this.imagesPath + this.IMAGEs[no];
                    if (this.spinner) { this.loader.assetsToLoad++; }
                }
            },
            onAssetLoaded: function (): void {
                this.loader.assetsLoaded++;
                if (this.loader.data) {
                    if (this.loader.assetsLoaded >= this.loader.assetsToLoad) {
                        PCM.Init(null, this.spinner.domElements.parent, this.loader.data, null);
                    }
                }
            },
            InitDefaultSettings: function (): void {
                this.svgs = {} as any;
                this.svgs.enabled = false;
                this.defaultSettings.ids = {
                    main: "pcm",
                    snow: "snow"
                };
                this.defaultSettings.canvas = {
                    width: 1080,
                    height: 1920,
                    rescaleMode: this.RESCALE_MODEs.MIN,
                    orientation: this.ORIENTATIONs.PORTRAIT
                };
                this.defaultSettings.cards = {
                    count: 31,
                    interactable: false,
                    reveal_delay: 3
                };
                this.defaultSettings.grid = {
                    zoom: 5,
                    zoom_time: 3,
                    width: parseInt("1100"),
                    height: parseInt("1800"),
                    dx: parseInt("210"),
                    dy: parseInt("210")
                };
                this.defaultSettings.snow = {
                    id: this.defaultSettings.ids.snow,
                    enabled: true,
                    fixed_dt: 0.016,
                    dom_scaling: false,
                    mobile_ratio: 0.5,
                    parent: "container",
                    shape: this.SHAPEs.CIRCLE
                };
                this.defaultSettings.anims = {
                    cards_appear: {
                        enabled: true,
                        delay: 50
                    },
                    card_tick_appear: {
                        enabled: true,
                        delay: 100
                    }
                };
            },
            Init: function (preload: string[] | null, parent: HTMLElement | null, data: PCMData, settings: PCMSettings | null): void {
                if (preload) {
                    this.Preload(preload, parent, data);
                    return;
                }
                if (window.location.hostname != "localhost") { this.online = true; }
                if (this.spinner) {
                    this.spinner.domElements.parent.innerHTML = '';
                    this.spinner.domElements.parent = null;
                    this.spinner = null;
                }
                if (this.isReady) { return; }
                this.isOnMobile = this.isMobileOrTablet();
                PCM._ids.boundUpdate = PCM.Update.bind(PCM);
                PCM._ids.update = window.requestAnimationFrame(PCM._ids.boundUpdate);
                PCM._ids.boundResize = PCM.Resize.bind(PCM);
                window.addEventListener('resize', PCM._ids.boundResize);
                if (settings) { this.settings = settings; }
                if (!this.settings.canvas) {
                    this.settings.canvas = { ...PCM.defaultSettings.canvas } as any;
                }
                if (this.settings.canvas) {
                    this.settings.canvas.aspectRatio = this.settings.canvas.width! / this.settings.canvas.height!;
                    this.settings.canvas.aspectRatioPercentage = this.settings.canvas.aspectRatio * 100;
                }
                if (!this.settings.cards) { this.settings.cards = PCM.defaultSettings.cards; }
                if (!this.settings.grid) { this.settings.grid = { ...PCM.defaultSettings.grid } as any; }
                if (!this.settings.ids) { this.settings.ids = PCM.defaultSettings.ids; }
                if (!this.settings.snow) { this.settings.snow = PCM.defaultSettings.snow; }
                if (!this.settings.anims) { this.settings.anims = PCM.defaultSettings.anims; }
                this.data = data;
                if (!parent) { this.error("Parent Container Not Found"); return; }
                const addHTML = '<div id="' + this.settings.ids!.main + '_container" class="pcm_container"><div id="' + this.settings.ids!.main + '" class="pcm"></div></div>';
                parent.innerHTML = addHTML;
                this.domElements = {} as any;
                this.domElements.parent = parent;
                this.domElements.self = document.getElementById(this.settings.ids!.main);
                this.domElements.container = document.getElementById(this.settings.ids!.main + "_container");
                if (this.data.bg) {
                    this.domElements.self!.style.backgroundImage = "url('" + this.data.bg + "')";
                    this.domElements.self!.style.backgroundRepeat = "no-repeat";
                    this.domElements.self!.style.backgroundPosition = "center center";
                    this.domElements.self!.style.backgroundSize = "cover";
                }
                if (!this.isOnMobile) {
                    this.domElements.self!.classList.add("pcm_desktop");
                    if (this.settings.canvas!.orientation == this.ORIENTATIONs.PORTRAIT) {
                        this.domElements.self!.style.setProperty("--ar", String(this.settings.canvas!.aspectRatio));
                    }
                } else {
                    this.domElements.self!.classList.add("pcm_mobile");
                }
                const addHTML2 = '<div id="' + this.settings.ids!.main + '_content" class="pcm_content" data-resize="scale"></div>' +
                    '<div id="' + this.settings.ids!.main + '_bottom" class="pcm_bot" data-resize="scale"><div id="' + this.settings.ids!.main + '_btn_cta" class="pcm_btn pcm_cta_btn" data-id="cta" data-enabled="1" data-anim="scale" style="display:none;">' + this.data.ctaButton.text + '</div></div>' +
                    '<div id="' + this.settings.ids!.main + '_top_left" class="pcm_top_left" data-resize="scale"><div id="' + this.settings.ids!.main + '_btn_back" class="pcm_btn pcm_back_btn" data-id="back" data-enabled="1" data-anim="scale" style="display:none;">↩</div></div>';
                this.domElements.self!.innerHTML = addHTML2;
                this.domElements.content = document.getElementById(this.settings.ids!.main + "_content");
                this.domElements.buttons = {} as any;
                this.domElements.buttons.cta = document.getElementById(this.settings.ids!.main + "_btn_cta");
                this.domElements.buttons.back = document.getElementById(this.settings.ids!.main + "_btn_back");
                this.addButtonsListeners([this.domElements.buttons.cta!, this.domElements.buttons.back!]);
                this.InitGrid();
                if (this.settings.snow!.enabled) { this.SnowManager.Init(); }
                this.params.time_scale = 1;
                if (!this.isOnMobile) {
                    document.addEventListener("mouseup", PCM.onTouchEnd);
                    if (this.domElements.container) {
                        const addHTML3 = '<div id="' + this.settings.ids!.main + '_mask_left" class="pcm_mask pcm_mask_left"></div><div id="' + this.settings.ids!.main + '_mask_right" class="pcm_mask pcm_mask_right"></div>';
                        this.domElements.container.insertAdjacentHTML("beforeend", addHTML3);
                        this.domElements.masks = {} as any;
                        this.domElements.masks.left = document.getElementById(this.settings.ids!.main + "_mask_left");
                        this.domElements.masks.right = document.getElementById(this.settings.ids!.main + "_mask_right");
                    }
                } else {
                    document.addEventListener("touchend", PCM.onTouchEnd);
                }
                this.isReady = true;
                this.Resize();
            },
            InitGrid: function (): void {
                if (this.grid) { return; }
                this.grid = {} as any;
                this.grid.domElements = {} as any;
                const addHTML = '<div id="' + this.settings.ids!.main + '_grid" class="pcm_grid"></div>';
                this.domElements.content!.insertAdjacentHTML("beforeend", addHTML);
                this.grid.domElements.self = document.getElementById(this.settings.ids!.main + "_grid");
                if (this.settings.snow!.enabled) {
                    const snowHTML = '<canvas id="' + this.settings.ids!.snow + '_p" class="pcm_snow_p"></canvas>';
                    switch (this.settings.snow!.parent) {
                        case "container":
                            this.domElements.container!.insertAdjacentHTML("beforeend", snowHTML);
                            break;
                        case "content":
                            this.domElements.content!.insertAdjacentHTML("beforeend", snowHTML);
                            break;
                        case "grid":
                            this.grid.domElements.self!.insertAdjacentHTML("beforeend", snowHTML);
                            break;
                        case "parent":
                            this.domElements.parent.insertAdjacentHTML("beforeend", snowHTML);
                            break;
                        default:
                            break;
                    }
                }
                let addHTML2 = '';
                this.settings.grid!.cols = Math.floor(this.settings.grid!.width! / this.settings.grid!.dx!);
                if (this.settings.grid!.cols! < 0) { this.settings.grid!.cols = 1; }
                this.settings.grid!.rows = 1;
                this.settings.grid!.size = this.settings.grid!.cols! * this.settings.grid!.rows!;
                while (this.settings.grid!.size! < this.settings.cards!.count) {
                    this.settings.grid!.rows!++;
                    this.settings.grid!.size = this.settings.grid!.cols! * this.settings.grid!.rows!;
                }
                this.params.grid = {} as any;
                this.params.grid.no = 0;
                this.params.grid.pos = [] as any[];
                let posX = 0;
                let posY = -(this.settings.grid!.rows! * 0.5 - 0.5) * this.settings.grid!.dy!;
                let cardsInRow = 0;
                let numberHTML = '';
                let symbolHTML = '';
                let frontHTML = '';
                let backHTML = '';
                let secondaryHTML = '';
                let statusClass = '';
                let prizeState = 0;
                for (let i = 0; i < this.settings.grid!.rows!; i++) {
                    cardsInRow = this.settings.cards!.count - this.params.grid.no;
                    if (cardsInRow > this.settings.grid!.cols!) { cardsInRow = this.settings.grid!.cols!; }
                    posX = -(cardsInRow * 0.5 - 0.5) * this.settings.grid!.dx!;
                    for (let j = 0; j < this.settings.grid!.cols!; j++) {
                        secondaryHTML = '';
                        backHTML = '';
                        prizeState = this.data.days[this.params.grid.no];
                        switch (prizeState) {
                            case this.PRIZE_STATEs.CLAIMED:
                                if (this.svgs.enabled) { secondaryHTML = '<div class="pcm_card_overlay"><div class="pcm_card_svg_tick">' + this.svgs.tick + '</div></div>'; }
                                else {
                                    let tick_style = '';
                                    if (this.settings.anims!.card_tick_appear.enabled) {
                                        tick_style = 'transform:scale(0); opacity:0;';
                                    }
                                    secondaryHTML = '<div class="pcm_card_overlay"><div class="pcm_card_tick pcm_atlas pcm_atlas_tick" style="' + tick_style + '"></div></div>';
                                }
                                statusClass = 'achieved';
                                break;
                            case this.PRIZE_STATEs.MISSED:
                                if (this.svgs.enabled) { secondaryHTML = '<div class="pcm_card_overlay"><div class="pcm_card_svg_cross">' + this.svgs.cross + '</div></div>'; }
                                else {
                                    let cross_style = '';
                                    if (this.settings.anims!.card_tick_appear.enabled) {
                                        cross_style = 'transform:scale(0); opacity:0;';
                                    }
                                    secondaryHTML = '<div class="pcm_card_overlay"><div class="pcm_card_cross pcm_atlas pcm_atlas_cross" style="' + cross_style + '"></div></div>';
                                }
                                statusClass = 'missed';
                                break;
                            case this.PRIZE_STATEs.AVAILABLE:
                                secondaryHTML = '';
                                statusClass = 'available';
                                let prizeImg = '';
                                let prizeText = '';
                                if (this.data.prize) {
                                    prizeImg = '<img class="pcm_card_prize_icon" src="' + this.data.prize.image + '"></img>'
                                    prizeText = '<h3 class="pcm_card_prize_text">' + this.data.prize.text + '</h3>'
                                }
                                backHTML = '<div class="pcm_card_face pcm_card_back"><div class="">' + prizeImg + prizeText + '</div></div>';
                                break;
                            case this.PRIZE_STATEs.LOCKED:
                                secondaryHTML = '<div class="pcm_card_lock">🔒</div>';
                                secondaryHTML = '<div class="pcm_card_lock"></div>';
                                statusClass = 'locked';
                                break;
                        }
                        symbolHTML = '<div class="pcm_atlas pcm_atlas_symbol_' + this.params.grid.no + ' pcm_card_front_symbol"></div>';
                        this.params.grid.pos.push({ x: posX, y: posY });
                        if (this.params.grid.no < this.settings.cards!.count) {
                            numberHTML = '<h3 class="pcm_card_number">' + (this.params.grid.no + 1) + '</h3>';
                            if (this.svgs.enabled) {
                                frontHTML = '<div class="pcm_card_face pcm_card_front pcm_card_front_svg ' + statusClass + '">' + this.svgs.front_face + symbolHTML + numberHTML + secondaryHTML + '</div>';
                            } else {
                                frontHTML = '<div class="pcm_card_face pcm_card_front pcm_card_front_img ' + statusClass + '">' + symbolHTML + numberHTML + secondaryHTML + '</div>';
                            }
                            addHTML2 = addHTML2 + '<div class="pcm_card_p" data-id="card_p" data-row="' + i + '" data-col="' + j + '" data-no="' + this.params.grid.no + '" data-state="' + prizeState + '" style="left:' + this.params.grid.pos[this.params.grid.no].x + 'px; top: ' + this.params.grid.pos[this.params.grid.no].y + 'px;">' +
                                '<div class="pcm_card" data-id="card" data-no="' + this.params.grid.no + '" data-enabled="1">' + frontHTML + backHTML +
                                '</div>' +
                                '</div>';
                        }
                        posX = posX + this.settings.grid!.dx!;
                        this.params.grid.no++;
                    }
                    posY = posY + this.settings.grid!.dy!;
                }
                this.grid.domElements.self!.insertAdjacentHTML("beforeend", addHTML2);
                this.grid.domElements.cards = this.grid.domElements.self!.querySelectorAll('[data-id="card_p"]');
                for (let no = 0; no < this.grid.domElements.cards.length; no++) {
                    if (this.grid.domElements.cards[no].getAttribute('data-id') == "card_p") {
                        if (parseInt(this.grid.domElements.cards[no].getAttribute('data-state')!) == this.PRIZE_STATEs.AVAILABLE) {
                            this.grid.domElements.todayCard = this.grid.domElements.cards[no].children[0] as HTMLElement;
                            if (this.settings.cards!.interactable) {
                                this.grid.domElements.todayCard.addEventListener('click', PCM.onClickHandler);
                            }
                        }
                    }
                }
                this.Animate();
            },
            Animate: function (): void {
                let anmi_timeline = 0;
                let anmi_timeline_1 = 0;
                if (this.settings.anims!.cards_appear.enabled) {
                    this.grid.domElements.cards.forEach((card: Element) => {
                        card.classList.add("pcm_card_popin");
                        (card as HTMLElement).style.animationDelay = anmi_timeline_1 + "ms";
                        anmi_timeline_1 = anmi_timeline_1 + PCM.settings.anims!.cards_appear.delay;
                    });
                }
                let anmi_timeline_2 = anmi_timeline_1;
                if (this.settings.anims!.card_tick_appear.enabled) {
                    for (let no = 0; no < this.grid.domElements.cards.length; no++) {
                        if (this.grid.domElements.cards[no].getAttribute('data-id') == "card_p") {
                            const state = parseInt(this.grid.domElements.cards[no].getAttribute('data-state')!);
                            if (state == this.PRIZE_STATEs.CLAIMED || state == this.PRIZE_STATEs.MISSED) {
                                let class_query = 'pcm_card_tick';
                                if (state == this.PRIZE_STATEs.CLAIMED) { class_query = '.pcm_card_tick'; }
                                if (state == this.PRIZE_STATEs.MISSED) { class_query = '.pcm_card_cross'; }
                                const dom_el = this.grid.domElements.cards[no].querySelector(class_query);
                                if (dom_el) {
                                    dom_el.classList.add("pcm_card_tick_popin");
                                    (dom_el as HTMLElement).style.animationDelay = anmi_timeline_2 + "ms";
                                    anmi_timeline_2 = anmi_timeline_2 + this.settings.anims!.card_tick_appear.delay;
                                }
                            }
                        }
                    }
                }
                anmi_timeline = anmi_timeline_1 + anmi_timeline_2;
                if (!this.settings.cards!.interactable) {
                    setTimeout(() => {
                        PCM.Zoom(true, PCM.grid.domElements.todayCard);
                    }, anmi_timeline + 500);
                }
            },
            Update: function (ts?: number): void {
                if (!ts) ts = performance.now();
                if (PCM.params) {
                    if (PCM.params.pre_ts === undefined) { PCM.params.pre_ts = ts; }
                    PCM.params.dt = (ts - PCM.params.pre_ts) / 1000;
                    if (PCM.params.dt == 0) { PCM.params.dt = 0.016; }
                    else if (PCM.params.dt > 0.2) { PCM.params.dt = 0.016; }
                    PCM.params.dt = PCM.params.dt * PCM.params.time_scale;
                    PCM.params.pre_ts = ts;
                    if (PCM.isReady) {
                        if (PCM.SnowManager) {
                            PCM.SnowManager.Update(PCM.params.dt);
                            PCM.SnowManager.Draw();
                        }
                    }
                }
                PCM._ids.update = window.requestAnimationFrame(PCM._ids.boundUpdate);
            },
            Resize: function (): void {
                if (!this.params) { return; }
                const params = this.params;
                params.screenWidth = this.domElements.parent.clientWidth;
                params.screenHeight = this.domElements.parent.clientHeight;
                params.aspectRatio = params.screenWidth / params.screenHeight;
                this.log(params.screenWidth + "<>" + params.screenHeight);
                if (this.settings.canvas) {
                    switch (this.settings.canvas.rescaleMode) {
                        case this.RESCALE_MODEs.WIDTH:
                            params.uiScale = params.screenWidth / this.settings.canvas.width!;
                            break;
                        case this.RESCALE_MODEs.HEIGHT:
                            params.uiScale = params.screenHeight / this.settings.canvas.height!;
                            break;
                        case this.RESCALE_MODEs.MIN:
                            params.uiScale = Math.min(params.screenWidth / this.settings.canvas.width!, params.screenHeight / this.settings.canvas.height!);
                            break;
                        case this.RESCALE_MODEs.MAX:
                            params.uiScale = Math.max(params.screenWidth / this.settings.canvas.width!, params.screenHeight / this.settings.canvas.height!);
                            break;
                    }
                }
                if (!this.domElements) { return; }
                const itemsToRescale = this.domElements.self!.querySelectorAll("[data-resize]");
                let itemScale = 1;
                itemsToRescale.forEach((item: Element) => {
                    itemScale = params.uiScale;
                    if ((item as HTMLElement).dataset['scalemul']) { itemScale = itemScale * parseFloat((item as HTMLElement).dataset['scalemul']!); }
                    switch ((item as HTMLElement).dataset['resize']) {
                        case "scale_w":
                            (item as HTMLElement).style.transform = 'scaleX(' + itemScale + ')';
                            break;

                        case "scale_h":
                            (item as HTMLElement).style.transform = 'scaleY(' + itemScale + ')';
                            break;

                        case "scale_hp":
                            (item as HTMLElement).style.height = parseInt((item as HTMLElement).dataset['initHeight']!) * itemScale + 'px';
                            break;

                        default:
                            (item as HTMLElement).style.transform = 'scale(' + itemScale + ',' + itemScale + ')';
                            break;
                    }
                });
                if (this.domElements) {
                    if (this.domElements.masks) {
                        if (this.domElements.container) {
                            const delta_width = this.domElements.container.clientWidth - this.domElements.self!.clientWidth;
                            if (delta_width > 0) {
                                this.domElements.masks.left!.style.width = (delta_width * 0.5) + 'px';
                                this.domElements.masks.right!.style.width = (delta_width * 0.5) + 'px';
                            }
                        }
                    }
                }
                if (this.SnowManager) {
                    if (this.SnowManager.canvas) {
                        this.SnowManager.Resize(params.screenWidth, params.screenHeight, params.uiScale);
                    }
                }
            },
            ResetSelection: function (): void {
                PCM.state = this.STATEs.DEFAULT;
                PCM.Zoom(false, PCM.params.btn);
            },
            Zoom: function (_in: boolean, btn: HTMLElement): void {
                let zoom = this.settings.grid!.zoom!;
                const centerX = 0;
                const centerY = 0;
                let delta_x = 0;
                let delta_y = 0;
                if (_in) {
                    this.params.isZoomed = true;
                    const card_p = this.grid.domElements.cards[parseInt(btn.dataset['no']!)] as HTMLElement;
                    zoom = this.settings.grid!.zoom!;
                    delta_x = (centerX - card_p.offsetLeft) * zoom;
                    delta_y = (centerY - card_p.offsetTop) * zoom;
                    setTimeout(() => {
                        PCM.HideSurroundingCards(parseInt(card_p.dataset['row']!), parseInt(card_p.dataset['col']!));
                        PCM.FlipCard(btn, "do");
                    }, PCM.settings.grid!.zoom_time! * 1000);
                    setTimeout(() => {
                        PCM.ShowCtaButtons();
                    }, PCM.settings.grid!.zoom_time! * 1000 + 2000);
                } else {
                    this.params.isZoomed = false;
                    PCM.FlipCard(btn, "reset");
                    zoom = 1;
                }
                this.grid.domElements.self!.style.transform = `translate(${delta_x}px, ${delta_y}px) scale(${zoom})`;
            },
            ShowCtaButtons: function (): void {
                this.domElements.buttons.back!.style.display = null;
                this.domElements.buttons.back!.classList.add("pcm_pop_in_out");
                this.domElements.buttons.cta!.style.display = null;
                this.domElements.buttons.cta!.classList.add("pcm_cat_btn_appear");
            },
            HideSurroundingCards: function (c_i: number, c_j: number): void {
                let delta_i = 0;
                let delta_j = 0;
                let hide = false;
                for (let no = 0; no < this.grid.domElements.cards.length; no++) {
                    hide = false;
                    delta_i = parseInt(this.grid.domElements.cards[no].getAttribute('data-row')!) - c_i;
                    delta_j = parseInt(this.grid.domElements.cards[no].getAttribute('data-col')!) - c_j;
                    if (Math.abs(delta_i) == 1 || Math.abs(delta_j) == 1) {
                        hide = true;
                    }
                    if (hide) {
                        (this.grid.domElements.cards[no] as HTMLElement).style.animationDelay = '';
                        this.grid.domElements.cards[no].classList.remove("pcm_card_popin");
                        this.grid.domElements.cards[no].classList.add("pcm_card_fade_in");
                    }
                }
            },
            FlipCard: function (card: HTMLElement, action: string): void {
                if (!card.classList.contains('pcm_transition_anim')) { card.classList.add("pcm_transition_anim"); }
                switch (action) {
                    case "do":
                        card.classList.add("pcm_flipped");
                        break;

                    case "reset":
                        card.classList.remove("pcm_flipped");
                        break;
                }
            },
            onClickHandler: (event: Event): void => {
                const btn = event.target as HTMLElement;
                const buttonId = btn.dataset['id'];
                const enabled = parseInt(btn.dataset['enabled']!);
                if (enabled == 1) {
                    switch (buttonId) {
                        case "card":
                            if (PCM.state == PCM.STATEs.DEFAULT) {
                                PCM.state = PCM.STATEs.ZOOMED;
                                PCM.params.btn = btn;
                                PCM.Zoom(true, btn);
                            }
                            break;

                        case "back":
                            this.router.navigateByUrl(PCM.data.backButton.url);
                            break;

                        case "cta":
                            this.router.navigateByUrl(PCM.data.ctaButton.url);
                            break;
                    }
                }
            },
            onBtnTouched: function (event: Event): void {
                const btn = (event.target as HTMLElement);
                if (btn) { PCM.inputs.btnTouched = btn; }
                else { return; }
                const enabled = parseInt(btn.dataset['enabled']!);
                if (enabled != 1) { return; }
                switch (btn.dataset['anim']) {
                    case "scale":
                        const btnScale = 0.95 * parseFloat(btn.dataset['scale']!);
                        btn.style.transform = "scale(" + btnScale + ")";
                        break;
                }
            },
            onTouchEnd: function (event: Event): void {
                if (PCM.inputs.btnTouched) {
                    switch (PCM.inputs.btnTouched.dataset['anim']) {
                        case "scale":
                            PCM.inputs.btnTouched.style.transform = "scale(" + parseFloat(PCM.inputs.btnTouched.dataset['scale']!) + ")";
                            PCM.inputs.btnTouched = null;
                            break;
                    }
                }
            },
            Remove: function (): void {
                if (!this.isReady) { return; }
                if (this._ids.update) {
                    cancelAnimationFrame(this._ids.update);
                    this._ids.update = null;
                }
                window.removeEventListener('resize', PCM._ids.boundResize);
                if (!this.isOnMobile) {
                    document.removeEventListener("mouseup", PCM.onTouchEnd);
                } else {
                    document.removeEventListener("touchend", PCM.onTouchEnd);
                }
                this.removeButtonsListeners([this.domElements.buttons.cta!, this.domElements.buttons.back!]);
                if (this.settings.cards!.interactable) {
                    if (this.grid && this.grid.domElements && this.grid.domElements.cards) {
                        this.grid.domElements.cards.forEach((card: Element) => {
                            const innerCard = card.children[0] as HTMLElement;
                            if (innerCard) innerCard.removeEventListener('click', PCM.onClickHandler);
                        });
                    }
                }
                if (this.domElements && this.domElements.container) {
                    this.domElements.container.remove();
                }
                this.domElements = null;
                this.grid = null;
                this.params = {};
                this.isReady = false;
            }
        };

        // Initialize SnowManager
        PCM.SnowManager = {
            parent: PCM,
            Init: function (): void {
                this.isReady = false;
                this.settings = this.parent.settings.snow!;
                this.domElements = {} as any;
                this.domElements.self = document.getElementById(this.settings.id + "_p");
                if (!this.domElements.self) {
                    const snowHTML = '<canvas id="' + this.settings.id + '_p" class="pcm_snow_p"></canvas>';
                    if (this.settings.enabled) {
                        switch (this.settings.parent) {
                            case "container":
                                this.parent.domElements.container!.insertAdjacentHTML("beforeend", snowHTML);
                                break;
                            case "content":
                                this.parent.domElements.content!.insertAdjacentHTML("beforeend", snowHTML);
                                break;
                            case "grid":
                                this.parent.grid.domElements.self!.insertAdjacentHTML("beforeend", snowHTML);
                                break;
                            case "parent":
                                this.parent.domElements.parent.insertAdjacentHTML("beforeend", snowHTML);
                                break;
                            default:
                                break;
                        }
                    }
                    this.domElements.self = document.getElementById(this.settings.id + "_p");
                }
                this.canvas = this.domElements.self as HTMLCanvasElement;
                this.ctx = this.canvas.getContext("2d")!;
                this.params = {} as any;
                this.parent.Resize();
                this.Resize(PCM.params.screenWidth, PCM.params.screenHeight, PCM.params.uiScale);
                let particles_count_mul = 1;
                if (this.parent.isOnMobile) { particles_count_mul = this.settings.mobile_ratio; }
                this.params.layers = [
                    { count: parseInt(String(40 * particles_count_mul)), size: [2, 4], speed: [20, 50], opacity: [0.2, 0.5] },
                    { count: parseInt(String(50 * particles_count_mul)), size: [4, 7], speed: [40, 80], opacity: [0.4, 0.7] },
                    { count: parseInt(String(25 * particles_count_mul)), size: [6, 12], speed: [60, 120], opacity: [0.6, 1] }
                ];
                this.particles = [] as Particle[];
                for (const layer of this.params.layers) {
                    for (let i = 0; i < layer.count; i++) {
                        const size = PCM.getRandom(layer.size[0], layer.size[1]);
                        this.particles.push({
                            x: PCM.getRandom(0, (this.params as any).width),
                            y: PCM.getRandom(0, (this.params as any).height),
                            radius: size,
                            speedY: PCM.getRandom(layer.speed[0], layer.speed[1]),
                            speedX: PCM.getRandom(-30, 30),
                            driftPhase: PCM.getRandom(0, Math.PI * 2),
                            driftSpeed: PCM.getRandom(0.5, 1.5),
                            opacity: PCM.getRandom(layer.opacity[0], layer.opacity[1])
                        });
                    }
                }
                this.CreateSprite();
                this.isReady = true;
            },
            CreateSprite: function (): void {
                const size = 32;
                const sprite = document.createElement("canvas");
                sprite.width = size;
                sprite.height = size;
                const sctx = sprite.getContext("2d")!;
                const grd = sctx.createRadialGradient(10, 10, 1, 10, 10, 10);
                grd.addColorStop(0, "rgba(255,255,255,1)");
                grd.addColorStop(1, "rgba(255,255,255,1)");
                sctx.fillStyle = grd;
                sctx.beginPath();
                sctx.arc(10, 10, 10, 0, Math.PI * 2);
                sctx.fill();
                this.sprite = sprite;
            },
            Update: function (dt: number): void {
                if (!this.isReady) { return; }
                if (this.settings.fixed_dt > 0) { dt = this.settings.fixed_dt; }
                for (const f of this.particles) {
                    f.y += f.speedY * dt;
                    f.driftPhase += f.driftSpeed * dt;
                    f.x += Math.sin(f.driftPhase) * f.speedX * dt;
                    if (f.y > (this.params as any).height) {
                        f.y = -f.radius;
                        f.x = PCM.getRandom(0, (this.params as any).width);
                        f.opacity = PCM.getRandom(0.3, 0.9);
                        f.radius = PCM.getRandom(2, 10);
                    }
                    if (f.x > (this.params as any).width) f.x = 0;
                    if (f.x < 0) f.x = (this.params as any).width;
                }
            },
            Draw: function (): void {
                if (!this.isReady) { return; }
                this.ctx.clearRect(0, 0, (this.params as any).width, (this.params as any).height);
                for (const f of this.particles) {
                    const size = f.radius * 2;
                    this.ctx.globalAlpha = f.opacity;
                    this.ctx.drawImage(
                        this.sprite,
                        f.x - f.radius,
                        f.y - f.radius,
                        size,
                        size
                    );
                    this.ctx.globalAlpha = 1;
                }
            },
            Resize: function (screenWidth: number, screenHeight: number, uiScale: number): void {
                if (this.settings.dom_scaling) {
                    (this.params as any).height = parseInt(String((screenHeight * 1.1) / uiScale));
                    if (PCM.isOnMobile) {
                        (this.params as any).width = parseInt(String(screenWidth / uiScale));
                    } else {
                        (this.params as any).width = this.parent.settings.canvas!.aspectRatio! * parseInt(String(screenHeight / uiScale));
                    }
                } else {
                    uiScale = 1;
                    (this.params as any).height = parseInt(String((screenHeight * 1.1) / uiScale));
                    if (PCM.isOnMobile) {
                        (this.params as any).width = parseInt(String(screenWidth / uiScale));
                    } else {
                        (this.params as any).width = this.parent.settings.canvas!.aspectRatio! * parseInt(String(screenHeight / uiScale));
                    }
                }
                this.canvas.style.width = (this.params as any).width + "px";
                this.canvas.style.height = (this.params as any).height + "px";
                this.canvas.width = (this.params as any).width;
                this.canvas.height = (this.params as any).height;
            }
        } as any;

        PCM.InitDefaultSettings();
        this.PCM = PCM;
    }
}
